import { motion } from "framer-motion";

export const PageHero = ({ eyebrow, title, lead, img }) => (
  <section className="grain relative overflow-hidden bg-[#0A3A6B] pt-[72px]" data-testid="page-hero">
    <motion.img src={img} alt="" className="absolute inset-0 h-full w-full object-cover opacity-35"
      initial={{ scale: 1.1 }} animate={{ scale: 1 }} transition={{ duration: 8, ease: "linear" }} />
    <div className="absolute inset-0 bg-gradient-to-r from-[#0A3A6B] via-[#0A3A6B]/85 to-[#0A3A6B]/40" />
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
      className="relative mx-auto max-w-7xl px-5 py-16 lg:px-10 lg:py-24">
      <p className="text-xs font-semibold uppercase tracking-[0.25em] text-sky-300">{eyebrow}</p>
      <h1 className="mt-4 max-w-3xl text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl" data-testid="page-title">{title}</h1>
      <p className="mt-5 max-w-2xl text-base leading-relaxed text-sky-50/85 md:text-lg">{lead}</p>
    </motion.div>
  </section>
);
